module.exports = __webpack_public_path__ + "static/media/crest.24ae8aab.svg";